import { Box, Flex, Text } from "theme-ui";
import { LegentPillProps } from "../../../../../types/dashboard.types";
import React from "react";

const LegendPill = ({ label, value, color }: LegentPillProps) => (
    <Flex
        sx={{
            alignItems: "center", bg: "#f5efe7", px: "8px", py: "4px", borderRadius: "6px", fontSize: "12px", fontWeight: 500, gap: "8px", height: "24px",
        }}
    >
        <Box sx={{ display: "flex", width: "10px", height: "10px", borderRadius: "2px", bg: color }} />
        <Text sx={{ color: "rgba(69, 53, 33, 1)", fontSize: ["12px", "9px", "10px", "12px"], fontWeight: 500 }}>{label}: {value}</Text>
    </Flex>
);

export default React.memo(LegendPill)